export const socialsData = {
    github: 'https://github.com/GauravBansal29',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/gaurav-bansal-11150b1bb/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@urrgb29',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}